import { useQuery } from '@tanstack/react-query';
import { payoutKeys } from './payout.keys';
import { getWithdrawalHistory } from './payout.service';
export const useWithdrawalHistory = (params) => {
    return useQuery({
        queryKey: payoutKeys.withdrawalHistory(params),
        queryFn: () => getWithdrawalHistory(params),
    });
};
